import { Injectable } from '@angular/core';
import { Settings } from '../../core';
declare const pendo: any;

export interface VisitorInfo {
    id: string ;
    role: string;
}

export interface AccountInfo {
    id?: string| number;
    sponsor?: string;
    site?: string;
    siteNumber?: string;
    city?: string;
    state?: string;
    region?: string;
}

@Injectable()
export class PendoService {

    private visitorInfo: VisitorInfo;

    constructor(private settings: Settings) {
    }

    public   pendoInitialization(userInfo: any, blsApiKey: string) {
        if (this.settings.emulatedUserId || !blsApiKey) { return; }
        this.setPendoScript(window, blsApiKey);
        const pendoInitObj: { visitor: VisitorInfo, account: AccountInfo } = {
            visitor: {
                id: userInfo.email,
                role: userInfo.audienceRole,
            },
            account: null
        };
        this.visitorInfo = pendoInitObj.visitor;
        pendo.initialize(pendoInitObj);
    }

    public updateSponsorPendoDetails(studyCard: any) {
        if (this.settings.emulatedUserId) { return; }
        const pendoInitObj: { visitor: VisitorInfo, account: AccountInfo } = {
            visitor: this.visitorInfo,
            account: {
                id: studyCard.protocolId,
                sponsor: studyCard.sponsorName,
            }
        };
        pendo.updateOptions(pendoInitObj);
    }

    public updateInvestigatorPendoDetails(site: any) {
        if (this.settings.emulatedUserId) { return; }
        const pendoInitObj: { visitor: VisitorInfo, account: AccountInfo } = {
            visitor: this.visitorInfo,
            account: {
                id: site.siteId,
                sponsor: site.study.sponsor,
                site: site.investigatorFullName,
                siteNumber: site.siteNum,
            }
        };
        pendo.updateOptions(pendoInitObj);
    }

    private setPendoScript(pendoRef: any, apiKey: string) {
        let pendoActions = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
        const windowPendoRef: any = pendoRef['pendo'] = pendoRef['pendo'] || {};
        windowPendoRef._q = windowPendoRef._q || [];
        let index: number;
        let count: number;
        for (index = 0, count = pendoActions.length; index < count; ++index) {
            (function (action: string) {
                windowPendoRef[action] = windowPendoRef[action] || function () {
                    windowPendoRef._q[action === pendoActions[0] ? 'unshift' : 'push']([action].concat([].slice.call(arguments, 0)));
                };
            })(pendoActions[index]);
        }
        let htmlElement: any = document.createElement('script');
        htmlElement.async = true;
        htmlElement.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
        let element: Element = document.getElementsByTagName('script')[0];
        element.parentNode.insertBefore(htmlElement, element);
    }
}